import { publicPath } from "../request/public";
export const permissionList = [
  {
    label: "我的发布",
    value: "1",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "1-1",
        label: "发布列表"
      },
      {
        value: "1-2",
        label: "添加发布"
      },
      {
        value: "1-3",
        label: "删除发布"
      },
      {
        value: "1-4",
        label: "编辑发布"
      },
      {
        value: "1-5",
        label: "查看发布"
      },
      {
        value: "1-6",
        label: "发布"
      },
      {
        value: "1-7",
        label: "下架"
      },
      {
        value: "1-8",
        label: "驳回"
      }
    ]
  },
  {
    label: "信息审核",
    value: "2",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "2-1",
        label: "审核列表"
      },
      {
        value: "2-2",
        label: "审核"
      },
      {
        value: "2-3",
        label: "一键审核"
      },
      {
        value: "2-4",
        label: "驳回"
      }
    ]
  },
  {
    label: "论坛版块管理",
    value: "3",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "3-1",
        label: "论坛列表"
      },
      {
        value: "3-2",
        label: "添加论坛"
      },
      {
        value: "3-3",
        label: "删除论坛"
      },
      {
        value: "3-4",
        label: "编辑论坛"
      },
      {
        value: "3-5",
        label: "隐藏论坛"
      }
    ]
  },
  {
    label: "专家库",
    value: "4",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "4-1",
        label: "专家列表"
      },
      {
        value: "4-2",
        label: "添加专家"
      },
      {
        value: "4-3",
        label: "删除专家"
      },
      {
        value: "4-4",
        label: "编辑专家"
      },
      {
        value: "4-5",
        label: "查看专家"
      },
      {
        value: "4-6",
        label: "导入专家"
      },
      {
        value: "4-7",
        label: "导出专家"
      }
    ]
  },
  {
    label: "商务对接",
    value: "5",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "5-1",
        label: "查看列表"
      },
      {
        value: "5-2",
        label: "下载申请表"
      }
    ]
  },
  {
    label: "统计分析",
    value: "6",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "6-1",
        label: "采购计划统计"
      },
      {
        value: "6-2",
        label: "论坛热点统计"
      }
    ]
  },
  {
    label: "角色权限",
    value: "7",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "7-1",
        label: "角色列表"
      },
      {
        value: "7-2",
        label: "添加角色"
      },
      {
        value: "7-3",
        label: "编辑角色"
      },
      {
        value: "7-4",
        label: "删除角色"
      }
    ]
  },
  {
    label: "用户权限",
    value: "8",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "8-1",
        label: "用户列表"
      },
      {
        value: "8-2",
        label: "添加用户"
      },
      {
        value: "8-3",
        label: "删除用户"
      },
      {
        value: "8-4",
        label: "编辑用户"
      },
      {
        value: "8-5",
        label: "禁用用户"
      },
      {
        value: "8-6",
        label: "启用用户"
      },
      {
        value: "8-7",
        label: "查看用户"
      },
      {
        value: "8-8",
        label: "重置密码"
      },
      {
        value: "8-9",
        label: "导入用户"
      },
      {
        value: "8-10",
        label: "导出用户"
      }
    ]
  },
  {
    label: "机构管理",
    value: "9",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "9-1",
        label: "机构列表"
      },
      {
        value: "9-2",
        label: "添加机构"
      },
      {
        value: "9-3",
        label: "删除机构"
      },
      {
        value: "9-4",
        label: "编辑机构"
      }
      // {
      //   value: '9-5',
      //   label: '导入机构',
      // },
      // {
      //   value: '9-6',
      //   label: '导出机构',
      // },
    ]
  },
  {
    label: "政策申报",
    value: "11",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "11-1",
        label: "项目发布"
      },
      {
        value: "11-2",
        label: "政策解读"
      },
      {
        value: "11-3",
        label: "项目咨询"
      },
      {
        value: "11-4",
        label: "申报预审"
      },
      {
        value: "11-5",
        label: "材料归档"
      }
    ]
  },
  {
    label: "其它",
    value: "10",
    checked: false,
    checkedList: [],
    data: [
      {
        value: "10-1",
        label: "轮播图管理"
      },
      {
        value: "10-2",
        label: "操作日志"
      }
    ]
  }
];

export const parseArray = (arr, num) => {
  const result = [];
  for (var i = 0; i < arr.length; i += num) {
    result.push(arr.slice(i, i + num));
  }
  return result;
};

export const accountReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,12}$/;
export const phoneReg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/;

export const userTemplate = "/muban.xlsx";
export const specialistTemplate = "/specialist.xlsx";
export const removeTAG = str => {
  return str.replace(/<[^>]+>/g, "");
};
export const editorAllConfig = {
  UEDITOR_HOME_URL: publicPath + "/UEditor/",
  serverUrl: publicPath + "/UEditor/php/controller.php",
  retainOnlyLabelPasted: true,
  toolbars: [
    [
      "undo", //撤销
      "redo", //重做
      "bold", //加粗
      "indent", //首行缩进
      "italic", //斜体
      "underline", //下划线
      "cleardoc", //清空文档
      "fontsize", //字号
      "forecolor", //字体颜色
      "backcolor", //背景色
      "simpleupload", //单图上传
      "insertvideo", //视频
      "justifyleft", //居左对齐
      "justifyright", //居右对齐
      "justifycenter", //居中对齐
      "justifyjustify", //两端对齐
      "fullscreen", //全屏
      "touppercase", //字母大写
      "tolowercase" //字母小写
    ]
  ]
};
export const forumEditorConfig = {
  UEDITOR_HOME_URL: publicPath + "/UEditor/",
  serverUrl: publicPath + "/UEditor/php/controller.php",
  retainOnlyLabelPasted: true,
  toolbars: [
    [
      "undo", //撤销
      "redo", //重做
      "cleardoc", //清空文档
      "simpleupload", //单图上传
      "fullscreen" //全屏
    ]
  ]
};
export const editorConfig = {
  UEDITOR_HOME_URL: publicPath + "/UEditor/",
  serverUrl: publicPath + "/UEditor/php/controller.php",
  retainOnlyLabelPasted: true,
  toolbars: [
    [
      "undo", //撤销
      "redo", //重做
      "bold", //加粗
      "indent", //首行缩进
      "italic", //斜体
      "underline", //下划线
      "cleardoc", //清空文档
      "fontsize", //字号
      "forecolor", //字体颜色
      "backcolor", //背景色
      "simpleupload", //单图上传
      "justifyleft", //居左对齐
      "justifyright", //居右对齐
      "justifycenter", //居中对齐
      "justifyjustify", //两端对齐
      "fullscreen", //全屏
      "touppercase", //字母大写
      "tolowercase" //字母小写
    ]
  ]
};
export const parseMillion = value => {
  //过万处理
  let num;
  if (value > 9999) {
    //大于9999显示x.xx万
    num = Math.floor(value / 100) / 100 + "W";
  } else if (value <= 9999 && value > -9999) {
    num = value;
  } else if (value < -9999) {
    //小于-9999显示-x.xx万
    num = -(Math.floor(Math.abs(value) / 1000) / 10) + "W";
  }
  return num;
};

export const compare = property => {
  return function(a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;
  };
};
export const matchReg = str => {
  let reg = /<\/?.+?\/?>/g;
  return str ? str.replace(reg, "") : "";
};

export const getValidationContent = content => {
  const validateImgs = content.match(/<img\b.*?(?:\>|\/>)/g)
    ? content
        .match(/<img\b.*?(?:\>|\/>)/g)
        .map(item =>
          JSON.parse(
            item
              .match(/\bsrc\b\s*=\s*[\'\"]?([^\'\"]*)[\'\"]?/g)[0]
              .replace("src=", "")
          )
        )
    : [];
  const validateVideos = content.match(/<video\b.*?(?:\>|\/>)/g)
    ? content
        .match(/<video\b.*?(?:\>|\/>)/g)
        .map(item =>
          JSON.parse(
            item
              .match(/\bsrc\b\s*=\s*[\'\"]?([^\'\"]*)[\'\"]?/g)[0]
              .replace("src=", "")
          )
        )
    : [];
  const validateContent = matchReg(content);
  return {
    validateImgs,
    validateVideos,
    validateContent
  };
};



// WEBPACK FOOTER //
// ./src/utils/index.js